import React, { useMemo, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config/apiBase';
import { platformNavItems, filterPlatformNavByPermission } from './platformNav';
import ConsoleSwitcher from './ConsoleSwitcher';
import '../components/product.css';
import './console.css';

const API_URL = API_BASE_URL;

function PlatformLayout() {
  const navigate = useNavigate();
  const { setIsAuthenticated, hasPlatformPermission, user, hasPlatformAccess } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  const visibleNav = useMemo(
    () => filterPlatformNavByPermission(platformNavItems, hasPlatformPermission),
    [hasPlatformPermission]
  );

  const logout = async (event) => {
    event.preventDefault();
    try {
      await fetch(`${API_URL}/logout/`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      // Still clear local auth state if the session is already gone.
    }
    setIsAuthenticated(false);
    navigate('/login');
  };

  if (!hasPlatformAccess) {
    return null;
  }

  return (
    <div className="console-shell platform-shell">
      <aside className={`console-sidebar${collapsed ? ' collapsed' : ''}`}>
        <div className="console-sidebar-header">
          <NavLink to="/platform/overview" className="console-brand">
            <span className="console-brand-text">Bakeonator Platform</span>
          </NavLink>
          <button
            type="button"
            className="console-collapse-btn d-none d-md-inline"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            onClick={() => setCollapsed((v) => !v)}
          >
            {collapsed ? '»' : '«'}
          </button>
        </div>
        <nav className="console-sidebar-nav" aria-label="Platform navigation">
          {visibleNav.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `console-nav-link${isActive ? ' active' : ''}`
              }
            >
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="console-sidebar-footer">
          {!collapsed && user && (
            <div className="small text-secondary mb-2">{user.email}</div>
          )}
          <Button variant="outline-light" size="sm" onClick={logout}>
            Log out
          </Button>
        </div>
      </aside>
      <div className="console-main">
        <header className="console-topbar">
          <div className="console-topbar-left">
            <span className="small text-light">Platform operations</span>
          </div>
          <div className="console-topbar-right">
            <ConsoleSwitcher />
          </div>
        </header>
        <main className="console-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default PlatformLayout;
